import React, { useState, useEffect } from "react";
import { Box, Text } from "@chakra-ui/react";
import PrivateBillingTable from "./PrivateBillingTable";
import useAxios from "axios-hooks";
import { useSetRecoilState } from "recoil";
import { toastState } from "atoms/toastState";
import LoadingSpinner from "components/feedback/LoadingSpinner";

const PrivateBilling = ({ id, station, refresh }) => {
  const [privateBillings, setPrivateBillings] = useState([]);
  const setToast = useSetRecoilState(toastState);

  // API call to get private billing data
  const [{ data, loading, error }, execute] = useAxios(
    { method: "GET", url: `/api/stations/privateBilling/${id}` },
    { manual: true }
  );

  // API call to update private billing
  const [{ loading: updateLoading }, executeUpdate] = useAxios(
    { method: "PATCH", url: `/api/stations/privateBilling/${id}` },
    { manual: true }
  );

  const fetchPrivateBillings = async () => {
    try {
      const response = await execute();
      const result = response.data.data;
      setPrivateBillings(result || []);
    } catch (err) {
      if (err?.code === "ERR_CANCELED") {
        return;
      }
      console.error(err);
      setToast({
        title: "Error fetching private billing data",
        status: "error",
        duration: 5000,
        isOpen: true,
        position: "top-right",
      });
    }
  };

  const updatePrivateBilling = async (userGroupId, price) => {
    try {
      const payload = {
        UserGroupId: userGroupId,
        Price: parseFloat(price),
        StationId: id,
      };

      await executeUpdate({ data: payload });

      setToast({
        title: "Private Billing Updated Successfully",
        status: "success",
        duration: 3000,
        isOpen: true,
        position: "top-right",
      });

      // Refetch data after successful update
      await fetchPrivateBillings();
    } catch (error) {
      if (error?.code === "ERR_CANCELED") {
        return;
      }
      const err = error?.response?.data?.error;
      setToast({
        title: err ? err?.error_code : "Error updating private billing",
        description: err ? err?.error_message : null,
        status: "error",
        duration: 5000,
        isOpen: true,
        position: "top-right",
      });
    }
  };

  useEffect(() => {
    fetchPrivateBillings();
  }, [id]);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <Box mt={5}>
      <Text fontSize="md" fontWeight="bold" color="gray.700" mb={4}>
        Private Pricing
      </Text>
      <PrivateBillingTable
        data={privateBillings}
        onUpdate={updatePrivateBilling}
        isUpdating={updateLoading}
      />
    </Box>
  );
};

export default PrivateBilling;
